import React, { useState, useEffect } from 'react';
import useScreenSize from '../hooks/useScreenSize';

const Home = ({ language }) => {
  const { isMobile, isTablet, width } = useScreenSize();
  const [showPopup, setShowPopup] = useState(false);

  // Show popup every 30 seconds
  useEffect(() => {
    // First popup after 10 seconds
    const initialTimer = setTimeout(() => {
      setShowPopup(true);
    }, 10000);

    // Then show popup every 30 seconds
    const interval = setInterval(() => {
      setShowPopup(true);
    }, 30000); // 30 seconds

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  const translations = {
    tr: {
      welcome: "Garage Ozcanlar'a Hoş Geldiniz",
      subtitle: "Profesyonel Otomobil Tamiri ve Bakım Hizmetleri",
      description: "Uzman ekibimizle, aracınızın en iyi bakımını sağlıyoruz. Kaliteli hizmet, uygun fiyat.",
      services: "Hizmetlerimiz",
      service1: "Motor Tamiri",
      service1_desc: "Profesyonel motor tamir ve bakım hizmetleri",
      service2: "Fren Sistemi",
      service2_desc: "Güvenli sürüş için fren sistemi kontrolü ve tamiri",
      service3: "Lastik Değişimi", 
      service3_desc: "Mevsimlik lastik değişimi ve balans ayarı",
      service4: "Genel Bakım",
      service4_desc: "Periyodik bakım ve kontrol hizmetleri",
      phone: "Dépannage: +32 485 93 59 29",
      webCaliskanTitle: "Web Siteniz İçin Profesyonel Çözüm",
      webCaliskanDesc: "Modern, responsive ve SEO optimize web siteleri. Otomotiv sektörü için özel tasarımlar.",
      webCaliskanCta: "Web Sitesi İsteyin"
    },
    fr: {
      welcome: "Bienvenue chez Garage Ozcanlar",
      services: "Nos Services",
      service1: "Réparation Moteur",
      service1_desc: "Services professionnels de réparation et maintenance moteur",
      service2: "Système de Freinage",
      service2_desc: "Contrôle et réparation du système de freinage pour une conduite sûre",
      service3: "Changement de Pneus",
      service3_desc: "Changement de pneus saisonniers et équilibrage",
      service4: "Entretien Général",
      service4_desc: "Services d'entretien et de contrôle périodiques",
      phone: "Dépannage: +32 485 93 59 29",
      webCaliskanTitle: "Solution Professionnelle pour Votre Site Web",
      webCaliskanDesc: "Sites web modernes, responsives et optimisés SEO. Designs spécialisés pour le secteur automobile.",
      webCaliskanCta: "Demander un Site Web"
    },
    nl: {
      welcome: "Welkom bij Garage Ozcanlar",
      subtitle: "Professionele Auto Reparatie en Onderhoud Services",
      description: "Met ons team van experts zorgen we voor het beste onderhoud van uw voertuig. Kwaliteitsservice, betaalbare prijs.",
      services: "Onze Services",
      service1: "Motor Reparatie",
      service1_desc: "Professionele motor reparatie en onderhoud services",
      service2: "Remsysteem",
      service2_desc: "Controle en reparatie van remsysteem voor veilig rijden",
      service3: "Banden Wisselen",
      service3_desc: "Seizoensgebonden bandenwisseling en balancering",
      service4: "Algemeen Onderhoud", 
      service4_desc: "Periodieke onderhoud en controle services",
      phone: "Telefoon: +32 485 93 59 29",
      webCaliskanTitle: "Professionele Oplossing voor Uw Website",
      webCaliskanDesc: "Moderne, responsive en SEO-geoptimaliseerde websites. Gespecialiseerde designs voor de automobielsector.",
      webCaliskanCta: "Website Aanvragen"
    }
  };

  const t = translations[language] || translations.tr;

  return (
    <div className="home-page">
      {/* Hero Section - Mercedes S-Class Background */}
      <section className="hero-area">
        <div className="hero-slider">
          <div className="single-hero" style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1544829099-b9a0c5303bea?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: isMobile ? 'scroll' : 'fixed', // Dynamic based on screen size
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            position: 'relative'
          }}>
            {/* Dark overlay for better text readability */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(220, 38, 38, 0.3))',
              zIndex: 1
            }}></div>
            
            <div className="container" style={{ position: 'relative', zIndex: 2 }}>
              <div className="row">
                <div className="col-lg-8 col-md-10 col-12">
                  <div className="hero-content hero-content-responsive" style={{
                    padding: isMobile ? '20px' : '40px',
                    textAlign: width <= 576 ? 'center' : 'left'
                  }}>
                    <h1 className="hero-title hero-title-responsive text-white" style={{
                      fontSize: width <= 576 ? '2rem' : 
                                width <= 768 ? '2.5rem' : '3.5rem',
                      lineHeight: width <= 576 ? '1.2' : '1.3',
                      marginBottom: width <= 576 ? '15px' : '20px',
                      fontWeight: '900',
                      textShadow: '3px 3px 6px rgba(0, 0, 0, 0.8)',
                      letterSpacing: width <= 576 ? '1px' : '2px'
                    }}>
                      {t.welcome}
                    </h1>
                    
                    <h3 className="hero-subtitle hero-subtitle-responsive" style={{
                      color: 'var(--gold-accent)',
                      fontSize: width <= 576 ? '1.1rem' : 
                                width <= 768 ? '1.3rem' : '1.5rem',
                      marginBottom: width <= 576 ? '15px' : '20px',
                      fontWeight: '600',
                      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                      lineHeight: width <= 576 ? '1.3' : '1.4'
                    }}>
                      {t.subtitle}
                    </h3>
                    
                    <p className="hero-description hero-description-responsive text-white" style={{
                      fontSize: width <= 576 ? '0.95rem' : 
                               width <= 768 ? '1.1rem' : '1.2rem',
                      marginBottom: width <= 576 ? '20px' : '30px',
                      lineHeight: '1.6',
                      textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8)',
                      maxWidth: width <= 576 ? '100%' : '80%'
                    }}>
                      {t.description}
                    </p>
                    
                    {/* CTA Buttons - Mobile Optimized */}
                    <div className="hero-cta hero-cta-responsive" style={{
                      display: 'flex',
                      flexDirection: width <= 576 ? 'column' : 'row',
                      gap: width <= 576 ? '15px' : '20px',
                      alignItems: width <= 576 ? 'stretch' : 'center',
                      marginBottom: '20px'
                    }}>
                      <a 
                        href={`tel:${t.phone.replace(/[^0-9+]/g, '')}`}
                        style={{
                          background: 'linear-gradient(45deg, var(--primary-red), var(--dark-red))',
                          color: 'white',
                          textDecoration: 'none',
                          padding: width <= 576 ? '15px 25px' : '15px 30px',
                          borderRadius: '25px',
                          fontSize: width <= 576 ? '1rem' : '1.1rem',
                          fontWeight: 'bold',
                          border: '2px solid var(--gold-accent)',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 4px 15px rgba(220, 38, 38, 0.4)',
                          textAlign: 'center',
                          minHeight: isMobile ? '48px' : 'auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseOver={(e) => {
                          if (!isMobile) {
                            e.target.style.transform = 'translateY(-3px)';
                            e.target.style.boxShadow = '0 6px 20px rgba(220, 38, 38, 0.6)';
                          }
                        }}
                        onMouseOut={(e) => {
                          if (!isMobile) {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 15px rgba(220, 38, 38, 0.4)';
                          }
                        }}
                      >
                        <i className="fas fa-phone me-2"></i>
                        {t.phone}
                      </a>
                      
                      <a 
                        href="https://www.facebook.com/ozcanlar.ozcan.77/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          background: 'transparent',
                          color: 'white',
                          textDecoration: 'none',
                          padding: width <= 576 ? '15px 25px' : '15px 30px',
                          borderRadius: '25px',
                          fontSize: width <= 576 ? '1rem' : '1.1rem',
                          fontWeight: 'bold',
                          border: '2px solid var(--gold-accent)',
                          transition: 'all 0.3s ease',
                          textAlign: 'center',
                          minHeight: isMobile ? '48px' : 'auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseOver={(e) => {
                          if (!isMobile) {
                            e.target.style.background = 'var(--gold-accent)';
                            e.target.style.color = 'var(--primary-black)';
                            e.target.style.transform = 'translateY(-3px)';
                          }
                        }}
                        onMouseOut={(e) => {
                          if (!isMobile) {
                            e.target.style.background = 'transparent';
                            e.target.style.color = 'white';
                            e.target.style.transform = 'translateY(0)';
                          }
                        }}
                      >
                        <i className="fab fa-facebook me-2"></i>
                        {language === 'fr' ? 'Nous Suivre' : 
                         language === 'tr' ? 'Takip Et' : 'Volg Ons'}
                      </a>
                    </div>
                    
                    {/* Quick Info - Mobile Optimized */}
                    <div className="hero-quick-info" style={{
                      display: 'flex',
                      flexDirection: width <= 576 ? 'column' : 'row',
                      gap: width <= 576 ? '10px' : '30px',
                      alignItems: width <= 576 ? 'center' : 'flex-start',
                      marginTop: '20px'
                    }}>
                      <div className="quick-info-item" style={{
                        background: 'rgba(0, 0, 0, 0.6)',
                        padding: width <= 576 ? '10px 15px' : '12px 20px',
                        borderRadius: '15px',
                        border: '1px solid var(--gold-accent)',
                        textAlign: 'center',
                        minWidth: isMobile ? '200px' : 'auto'
                      }}>
                        <i className="fas fa-clock" style={{ 
                          color: 'var(--gold-accent)', 
                          marginRight: '8px',
                          fontSize: width <= 576 ? '14px' : '16px'
                        }}></i>
                        <span style={{ 
                          color: 'white', 
                          fontSize: width <= 576 ? '0.85rem' : '0.9rem',
                          fontWeight: '500'
                        }}>
                          {language === 'fr' ? 'Lun-Ven: 8h-18h' : 
                           language === 'tr' ? 'Pts-Cum: 8-18' : 'Ma-Vr: 8u-18u'}
                        </span>
                      </div>
                      
                      <div className="quick-info-item" style={{
                        background: 'rgba(0, 0, 0, 0.6)',
                        padding: width <= 576 ? '10px 15px' : '12px 20px',
                        borderRadius: '15px',
                        border: '1px solid var(--gold-accent)',
                        textAlign: 'center',
                        minWidth: isMobile ? '200px' : 'auto'
                      }}>
                        <i className="fas fa-map-marker-alt" style={{ 
                          color: 'var(--gold-accent)', 
                          marginRight: '8px',
                          fontSize: width <= 576 ? '14px' : '16px'
                        }}></i>
                        <span style={{ 
                          color: 'white', 
                          fontSize: width <= 576 ? '0.85rem' : '0.9rem',
                          fontWeight: '500'
                        }}>
                          Evergem, Belgique
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section - Premium */}
      <section className="services-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title text-center">
                <h2 style={{
                  color: 'var(--primary-black)',
                  fontSize: '3rem',
                  fontWeight: '900',
                  textTransform: 'uppercase',
                  marginBottom: '3rem',
                  position: 'relative'
                }}>{t.services}</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="single-service text-center" style={{
                background: 'var(--white)',
                padding: '40px 20px',
                borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                border: '3px solid transparent',
                transition: 'all 0.4s ease',
                height: '320px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div className="service-icon" style={{
                    marginBottom: '20px'
                  }}>
                    <i className="fas fa-cogs" style={{
                      fontSize: '3rem',
                      color: 'var(--primary-red)',
                      marginBottom: '15px'
                    }}></i>
                  </div>
                  <h4 style={{
                    color: 'var(--primary-black)',
                    marginBottom: '15px',
                    fontSize: '1.3rem',
                    fontWeight: '700',
                    minHeight: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>{t.service1}</h4>
                  <p style={{
                    color: 'var(--grey-dark)',
                    fontSize: '0.95rem',
                    lineHeight: '1.6',
                    minHeight: '60px',
                    marginBottom: '20px'
                  }}>{t.service1_desc}</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="single-service text-center" style={{
                background: 'var(--white)',
                padding: '40px 20px',
                borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                border: '3px solid transparent',
                transition: 'all 0.4s ease',
                height: '320px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div className="service-icon" style={{
                    marginBottom: '20px'
                  }}>
                    <i className="fas fa-car-crash" style={{
                      fontSize: '3rem',
                      color: 'var(--primary-red)',
                      marginBottom: '15px'
                    }}></i>
                  </div>
                  <h4 style={{
                    color: 'var(--primary-black)',
                    marginBottom: '15px',
                    fontSize: '1.3rem',
                    fontWeight: '700',
                    minHeight: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>{t.service2}</h4>
                  <p style={{
                    color: 'var(--grey-dark)',
                    fontSize: '0.95rem',
                    lineHeight: '1.6',
                    minHeight: '60px',
                    marginBottom: '20px'
                  }}>{t.service2_desc}</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="single-service text-center" style={{
                background: 'var(--white)',
                padding: '40px 20px',
                borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                border: '3px solid transparent',
                transition: 'all 0.4s ease',
                height: '320px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div className="service-icon" style={{
                    marginBottom: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      <i className="fas fa-tire" style={{
                        fontSize: '3rem',
                        color: 'var(--primary-red)',
                        display: 'block'
                      }}></i>
                    </div>
                    <i className="fas fa-sync-alt" style={{
                      fontSize: '1rem',
                      color: 'var(--gold-accent)',
                      background: 'white',
                      borderRadius: '50%',
                      padding: '6px',
                      border: '2px solid var(--primary-red)',
                      marginTop: '5px'
                    }}></i>
                  </div>
                  <h4 style={{
                    color: 'var(--primary-black)',
                    marginBottom: '15px',
                    fontSize: '1.3rem',
                    fontWeight: '700',
                    minHeight: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>{t.service3}</h4>
                  <p style={{
                    color: 'var(--grey-dark)',
                    fontSize: '0.95rem',
                    lineHeight: '1.6',
                    minHeight: '60px',
                    marginBottom: '20px'
                  }}>{t.service3_desc}</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="single-service text-center" style={{
                background: 'var(--white)',
                padding: '40px 20px',
                borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                border: '3px solid transparent',
                transition: 'all 0.4s ease',
                height: '320px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div className="service-icon" style={{
                    marginBottom: '20px'
                  }}>
                    <i className="fas fa-wrench" style={{
                      fontSize: '3rem',
                      color: 'var(--primary-red)',
                      marginBottom: '15px'
                    }}></i>
                  </div>
                  <h4 style={{
                    color: 'var(--primary-black)',
                    marginBottom: '15px',
                    fontSize: '1.3rem',
                    fontWeight: '700',
                    minHeight: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>{t.service4}</h4>
                  <p style={{
                    color: 'var(--grey-dark)',
                    fontSize: '0.95rem',
                    lineHeight: '1.6',
                    minHeight: '60px',
                    marginBottom: '20px'
                  }}>{t.service4_desc}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-area" style={{
        padding: '100px 0',
        position: 'relative'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title text-center" style={{ marginBottom: '60px' }}>
                <h2 style={{ 
                  color: 'var(--primary-black)',
                  fontSize: '3rem',
                  fontWeight: '900',
                  textTransform: 'uppercase'
                }}>
                  {language === 'fr' ? 'Témoignages Clients' : 
                   language === 'tr' ? 'Müşteri Yorumları' : 
                   'Klantbeoordelingen'}
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="testimonial-item" style={{
                background: 'white',
                padding: '30px',
                borderRadius: '15px',
                border: '2px solid var(--primary-red)',
                marginBottom: '30px',
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div className="stars" style={{ marginBottom: '20px' }}>
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa fa-star" style={{ color: 'var(--gold-accent)', marginRight: '5px' }}></i>
                  ))}
                </div>
                <p style={{ color: 'var(--grey-dark)', fontStyle: 'italic', marginBottom: '20px', fontSize: '16px' }}>
                  {language === 'fr' ? '"Service exceptionnel ! Mon BMW a retrouvé sa performance d\'origine. Je recommande vivement !"' :
                   language === 'tr' ? '"Olağanüstü hizmet! BMW\'im orijinal performansını geri kazandı. Şiddetle tavsiye ederim!"' :
                   '"Uitzonderlijke service! Mijn BMW heeft zijn originele prestaties teruggekregen. Ik raad het ten zeerste aan!"'}
                </p>
                <div className="client-info" style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="client-avatar" style={{
                    width: '50px',
                    height: '50px',
                    background: 'linear-gradient(45deg, var(--primary-red), var(--gold-accent))',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px'
                  }}>
                    <i className="fa fa-user" style={{ color: 'white', fontSize: '20px' }}></i>
                  </div>
                  <div>
                    <h6 style={{ color: 'var(--primary-red)', margin: '0', fontSize: '16px', fontWeight: 'bold' }}>Marie D.</h6>
                    <small style={{ color: 'var(--grey-light)' }}>BMW X5</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="testimonial-item" style={{
                background: 'white',
                padding: '30px',
                borderRadius: '15px',
                border: '2px solid var(--primary-red)',
                marginBottom: '30px',
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div className="stars" style={{ marginBottom: '20px' }}>
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa fa-star" style={{ color: 'var(--gold-accent)', marginRight: '5px' }}></i>
                  ))}
                </div>
                <p style={{ color: 'var(--grey-dark)', fontStyle: 'italic', marginBottom: '20px', fontSize: '16px' }}>
                  {language === 'fr' ? '"Travail soigné et prix honnête. L\'équipe est professionnelle et à l\'écoute."' :
                   language === 'tr' ? '"Özenli iş ve dürüst fiyat. Ekip profesyonel ve dinleyici."' :
                   '"Zorgvuldig werk en eerlijke prijs. Het team is professioneel en luistert goed."'}
                </p>
                <div className="client-info" style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="client-avatar" style={{
                    width: '50px',
                    height: '50px',
                    background: 'linear-gradient(45deg, var(--primary-red), var(--gold-accent))',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px'
                  }}>
                    <i className="fa fa-user" style={{ color: 'white', fontSize: '20px' }}></i>
                  </div>
                  <div>
                    <h6 style={{ color: 'var(--primary-red)', margin: '0', fontSize: '16px', fontWeight: 'bold' }}>Ahmed K.</h6>
                    <small style={{ color: 'var(--grey-light)' }}>Mercedes C-Class</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="testimonial-item" style={{
                background: 'white',
                padding: '30px',
                borderRadius: '15px',
                border: '2px solid var(--primary-red)',
                marginBottom: '30px',
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div className="stars" style={{ marginBottom: '20px' }}>
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa fa-star" style={{ color: 'var(--gold-accent)', marginRight: '5px' }}></i>
                  ))}
                </div>
                <p style={{ color: 'var(--grey-dark)', fontStyle: 'italic', marginBottom: '20px', fontSize: '16px' }}>
                  {language === 'fr' ? '"Rapidité et efficacité ! Problème résolu en moins de 24h. Je reviendrai !"' :
                   language === 'tr' ? '"Hız ve verimlilik! Sorun 24 saatten kısa sürede çözüldü. Tekrar geleceğim!"' :
                   '"Snelheid en efficiëntie! Probleem opgelost in minder dan 24u. Ik kom terug!"'}
                </p>
                <div className="client-info" style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="client-avatar" style={{
                    width: '50px',
                    height: '50px',
                    background: 'linear-gradient(45deg, var(--primary-red), var(--gold-accent))',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px'
                  }}>
                    <i className="fa fa-user" style={{ color: 'white', fontSize: '20px' }}></i>
                  </div>
                  <div>
                    <h6 style={{ color: 'var(--primary-red)', margin: '0', fontSize: '16px', fontWeight: 'bold' }}>Jan V.</h6>
                    <small style={{ color: 'var(--grey-light)' }}>Audi A4</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-area" style={{
        padding: '80px 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          background: 'url(https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=60)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: '0.1'
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: '2' }}>
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center">
              <h2 style={{ 
                color: 'white',
                fontSize: '42px',
                marginBottom: '20px',
                fontWeight: '900',
                textTransform: 'uppercase'
              }}>
                {language === 'fr' ? 'Votre Voiture Mérite le Meilleur !' : 
                 language === 'tr' ? 'Arabanız En İyisini Hak Ediyor !' : 
                 'Uw Auto Verdient het Beste !'}
              </h2>
              <p style={{ 
                color: 'white',
                fontSize: '20px',
                marginBottom: '40px',
                fontWeight: '300'
              }}>
                {language === 'fr' ? 'Contactez-nous dès maintenant pour un devis gratuit et personnalisé' : 
                 language === 'tr' ? 'Ücretsiz ve kişiselleştirilmiş teklif için hemen bize ulaşın' : 
                 'Neem nu contact met ons op voor een gratis en gepersonaliseerde offerte'}
              </p>
              <div className="cta-buttons">
                <a href="tel:+32485935929" style={{
                  background: 'linear-gradient(45deg, var(--gold-accent), #f59e0b)',
                  color: 'var(--primary-black)',
                  padding: '20px 40px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  borderRadius: '50px',
                  marginRight: '20px',
                  display: 'inline-block',
                  transition: 'all 0.3s ease',
                  border: '3px solid white',
                  textTransform: 'uppercase'
                }}>
                  <i className="fa fa-phone" style={{ marginRight: '10px' }}></i>
                  {language === 'fr' ? 'Appeler Maintenant' : 
                   language === 'tr' ? 'Şimdi Ara' : 
                   'Nu Bellen'}
                </a>
                <a href="https://www.facebook.com/ozcanlar.ozcan.77/" target="_blank" rel="noopener noreferrer" style={{
                  background: 'transparent',
                  color: 'white',
                  padding: '20px 40px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  borderRadius: '50px',
                  display: 'inline-block',
                  transition: 'all 0.3s ease',
                  border: '3px solid white',
                  textTransform: 'uppercase'
                }}>
                  <i className="fab fa-facebook" style={{ marginRight: '10px' }}></i>
                  Facebook
                </a>
              </div>
              <div style={{ marginTop: '30px' }}>
                <small style={{ 
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: '16px'
                }}>
                  <i className="fa fa-shield" style={{ marginRight: '8px', color: 'var(--gold-accent)' }}></i>
                  {language === 'fr' ? 'Devis gratuit • Dépannage 24h/24' : 
                   language === 'tr' ? 'Ücretsiz teklif • 24 saat hizmet' : 
                   'Gratis offerte • 24u service'}
                </small>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Web-Caliskan Pop-up Advertisement */}
      {showPopup && (
        <div 
          className="popup-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99999999,
            animation: 'fadeIn 0.3s ease',
            padding: width <= 768 ? '20px' : '40px',
            boxSizing: 'border-box'
          }}
          onClick={closePopup}
        >
          <div 
            className="popup-content"
            style={{
              background: 'linear-gradient(135deg, var(--primary-black), var(--dark-black))',
              borderRadius: '20px',
              padding: width <= 576 ? '20px 15px' : 
                       width <= 768 ? '25px 20px' : 
                       width <= 992 ? '40px 30px' :
                       width <= 1200 ? '45px 35px' : '50px 40px',
              maxWidth: width <= 576 ? 'calc(100% - 20px)' :
                        width <= 768 ? 'calc(100% - 40px)' :
                        width <= 992 ? '500px' :
                        width <= 1200 ? '600px' : '700px',
              width: '100%',
              position: 'relative',
              border: '3px solid var(--primary-red)',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
              animation: 'slideUp 0.3s ease',
              margin: width <= 768 ? '20px' : '0 auto'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closePopup}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'var(--primary-red)',
                border: 'none',
                borderRadius: '50%',
                width: '35px',
                height: '35px',
                color: 'white',
                fontSize: '18px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'var(--dark-red)';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'var(--primary-red)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>

            <div style={{ textAlign: 'center' }}>
              {/* Badge */}
              <div style={{
                display: 'inline-block',
                background: 'var(--gold-accent)',
                color: 'var(--primary-black)',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 'bold',
                marginBottom: '20px',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                {language === 'fr' ? 'Partenaire Recommandé' : 
                 language === 'tr' ? 'Önerilen Partner' : 
                 'Aanbevolen Partner'}
              </div>
              
              {/* Website Logo */}
              <div style={{
                background: 'linear-gradient(145deg, #f8fafc, #e2e8f0)',
                borderRadius: '15px',
                padding: '20px',
                marginBottom: '20px',
                border: '2px solid var(--gold-accent)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img 
                  src="/img/wclogo.png" 
                  alt="Web-Caliskan.fr Logo"
                  style={{
                    maxWidth: width <= 576 ? '100px' : 
                              width <= 768 ? '110px' : '120px',
                    maxHeight: width <= 576 ? '60px' : 
                               width <= 768 ? '70px' : '80px',
                    width: 'auto',
                    height: 'auto',
                    marginBottom: '10px',
                    objectFit: 'contain'
                  }}
                />
                <h4 style={{
                  color: 'var(--primary-black)',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  margin: '0 0 5px 0'
                }}>web-caliskan.fr</h4>
                <p style={{
                  color: 'var(--grey-dark)',
                  fontSize: '0.9rem',
                  margin: 0,
                  textAlign: 'center'
                }}>
                  {language === 'fr' ? 'Création de sites web' : 
                   language === 'tr' ? 'Web sitesi oluşturma' : 
                   'Website creatie'}
                </p>
              </div>
              
              {/* Title */}
              <h3 style={{
                color: 'white',
                fontSize: width <= 576 ? '1.3rem' : 
                         width <= 768 ? '1.5rem' : 
                         width <= 992 ? '1.7rem' : 
                         width <= 1200 ? '1.8rem' : '2rem',
                fontWeight: '800',
                marginBottom: '15px',
                lineHeight: '1.2'
              }}>
                {t.webCaliskanTitle}
              </h3>
              
              {/* Description */}
              <p style={{
                color: 'var(--grey-light)',
                fontSize: width <= 576 ? '0.85rem' :
                         width <= 768 ? '0.9rem' : 
                         width <= 992 ? '0.95rem' : '1rem',
                lineHeight: '1.6',
                marginBottom: '20px',
                maxWidth: '100%'
              }}>
                {t.webCaliskanDesc}
              </p>
              
              {/* Features */}
              <div style={{ 
                marginBottom: '25px',
                textAlign: 'left',
                maxWidth: width <= 768 ? '100%' : '400px',
                margin: '0 auto 25px auto'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  fontSize: width <= 576 ? '12px' : '14px'
                }}>
                  <i className="fas fa-check-circle" style={{
                    color: 'var(--gold-accent)',
                    marginRight: '10px'
                  }}></i>
                  <span style={{ color: 'white' }}>
                    {language === 'fr' ? 'Design responsive & moderne' : 
                     language === 'tr' ? 'Responsive ve modern tasarım' : 
                     'Responsive & modern ontwerp'}
                  </span>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  fontSize: width <= 576 ? '12px' : '14px'
                }}>
                  <i className="fas fa-check-circle" style={{
                    color: 'var(--gold-accent)',
                    marginRight: '10px'
                  }}></i>
                  <span style={{ color: 'white' }}>
                    {language === 'fr' ? 'Optimisation SEO incluse' : 
                     language === 'tr' ? 'SEO optimizasyonu dahil' : 
                     'SEO optimalisatie inbegrepen'}
                  </span>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: width <= 576 ? '12px' : '14px'
                }}>
                  <i className="fas fa-check-circle" style={{
                    color: 'var(--gold-accent)',
                    marginRight: '10px'
                  }}></i>
                  <span style={{ color: 'white' }}>
                    {language === 'fr' ? 'Support technique dédié' : 
                     language === 'tr' ? 'Özel teknik destek' : 
                     'Toegewijde technische ondersteuning'}
                  </span>
                </div>
              </div>
              
              {/* CTA Button */}
              <a 
                href="https://web-caliskan.fr" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  background: 'linear-gradient(45deg, var(--primary-red), var(--dark-red))',
                  color: 'white',
                  textDecoration: 'none',
                  padding: width <= 576 ? '10px 20px' :
                           width <= 768 ? '12px 25px' : 
                           width <= 992 ? '14px 28px' : '15px 30px',
                  borderRadius: '25px',
                  fontSize: width <= 576 ? '0.8rem' :
                           width <= 768 ? '0.9rem' : 
                           width <= 992 ? '0.95rem' : '1rem',
                  fontWeight: 'bold',
                  border: '2px solid var(--gold-accent)',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(220, 38, 38, 0.4)',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  width: width <= 576 ? '100%' : 'auto',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  if (!isMobile) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(220, 38, 38, 0.6)';
                  }
                }}
                onMouseOut={(e) => {
                  if (!isMobile) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(220, 38, 38, 0.4)';
                  }
                }}
              >
                <i className="fas fa-globe me-2"></i>
                {t.webCaliskanCta}
              </a>
              
              {/* Dismiss Text */}
              <p style={{
                color: 'var(--grey-light)',
                fontSize: '12px',
                marginTop: '15px',
                marginBottom: 0
              }}>
                {language === 'fr' ? 'Cliquez n\'importe où pour fermer' : 
                 language === 'tr' ? 'Kapatmak için herhangi bir yere tıklayın' : 
                 'Klik ergens om te sluiten'}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;